export default __webpack_public_path__ + "static/media/mini-11.f0f5684d.jpg";